import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useReducer } from "react";
import { useHistory } from "react-router-dom";

import { fetchDlpPolicy } from "../../../api/policy";
import { Button } from "../../../components/buttons/Button";
import { Divider } from "../../../components/dividers/Divider";
import { SearchLoader } from "../../../components/loaders/searchLoader/SearchLoader";
import { INSIS_SYSTEM_ID } from "../../../constants/constants";
import { POLICY_NR_QUERY_PARAM } from "../../policyDetails/PolicyDetails";
import { SearchByPolicyNumberFields } from "../searchByPolicyNumberFields/SearchByPolicyNumberFields";
import styles from "./SearchDlpPolicy.module.scss";
import { initialState, searchDlpPolicyReducer } from "./SearchDlpPolicy.state";

interface Props {
  fields: Record<string, Field<string & { href: string }>>;
}

export const SearchDlpPolicy = ({ fields }: Props) => {
  const history = useHistory();
  const [{ loading, message, policyNumber }, dispatch] = useReducer(searchDlpPolicyReducer, initialState);

  const handleUpdatePolicyNumber = (data: { policyNumber?: string }) => {
    dispatch({ type: "UPDATE_POLICY_NUMBER", payload: { policyNumber: data.policyNumber } });
  };

  const retrieveDlpPolicy = async () => {
    if (!policyNumber) {
      return;
    }

    dispatch({ type: "FETCH_DATA" });

    try {
      const policy = await fetchDlpPolicy(policyNumber);

      if (policy.systemId == INSIS_SYSTEM_ID) {
        history.push(`${fields.DlpDetailPageLink.value.href}?${POLICY_NR_QUERY_PARAM}=${policyNumber}`);
      } else {
        history.push(`${fields.DetailPageLink.value.href}?${POLICY_NR_QUERY_PARAM}=${policyNumber}`);
      }
    } catch {
      dispatch({
        type: "FETCH_ERROR",
        payload: { message: "De polis kan niet gevonden worden." },
      });
    }
  };

  return (
    <>
      <div className={styles.searchDlpPolicy__container}>
        <SearchByPolicyNumberFields
          fields={fields}
          handleUpdatePolicyNumber={handleUpdatePolicyNumber}
          values={{ policyNumber }}
        />
        <div className={styles.searchDlpPolicy__searchButton}>
          <Button loading={loading} leading={<i className="icon icon-search" />} onClick={retrieveDlpPolicy}>
            Openen
          </Button>
        </div>
      </div>
      <Divider type="horizontal" />
      <SearchLoader text={message ?? "Zoek op basis van polisnummer."} />
    </>
  );
};
